<div class="modal-header" id="confirmation-cse-stock-modal-title">
    <h3 class="modal-title" id="modal-title" translate="CONFIRMATION_CSE_STOCK_MODAL_TITLE"></h3>
</div>
<div class="modal-body" id="modal-body" translate="CONFIRMATION_CSE_STOCK_MODAL_BODY"></div>
<div class="modal-footer d-flex">
    <button
        class="btn btn-primary"
        type="button"
        (click)="openOtherStock()"
        translate="CONFIRMATION_CSE_STOCK_MODAL_OTHER_STOCK_LABEL"
    ></button>
    <button
        class="btn btn-primary"
        type="button"
        (click)="openBootStock()"
        translate="CONFIRMATION_CSE_STOCK_MODAL_BOOT_STOCK_LABEL"
    ></button>
    <button
        class="btn btn-secondary ml-auto"
        type="button"
        (click)="onNoClicked()"
        translate="CONFIRMATION_CSE_STOCK_MODAL_NO_LABEL"
    ></button>
</div>
